import { Department } from "models/Department";
import { Office } from "models/Office";

export type User = {
  id: string;
  userName: string;
  password: string | null;
  confirmPassword: string | null;
  email: string;
  phone: string;
  state: UserState;
  companyId: string | null;
  companyName: string | null;
  controllerId: string | null;
  controllerName: string | null;
  articleTime: string | null;
  articleTimeInCar: string | null;
  pyramidSignature: string | null;
  assignedOrders: string[];
  anstnrHogia: string | null;
  appleId: string | null;
  role: UserRole;
  requestedCompanyName: string | null;
  validatedAt: String | null;
  office: Office | null;
  departments: Department[];
  isOrderReviewer: boolean;

  // Slated for removal in favor of `role` field
  /** @deprecated Use `role === UserRole.ADMIN` instead */ admin: boolean;
  /** @deprecated Use `role === UserRole.EMPLOYEE` instead */ coworker: boolean;
  /** @deprecated Use `role === UserRole.PAYROLL` instead */ econ: boolean;
  /** @deprecated Use `role === UserRole.EXTERNAL_INSTALLER` instead */ externalInstaller: boolean;
  /** @deprecated Use `role === UserRole.INTERNAL_INSTALLER` instead */ internalInstaller: boolean;
  /** @deprecated Use `role === UserRole.SALES` instead */ sales: boolean;
};

export type AbsentUser = {
  userId: string;
  userName: string;
  userRole: UserRole;
  reason: string;
  from: string;
  to: string;
  comment: string | null;
};

export type UserState = "CREATED" | "PENDING" | "ACTIVE" | "INACTIVE";

export enum UserRole {
  ADMIN = "ADMIN",
  INTERNAL_INSTALLER = "INTERNAL_INSTALLER",
  EXTERNAL_INSTALLER = "EXTERNAL_INSTALLER",
  EMPLOYEE = "EMPLOYEE",
  PAYROLL = "PAYROLL",
  USER_ADMIN = "USER_ADMIN",
  NONE = "NONE",
  SALES = "SALES",
}

export const USER_ROLES: readonly UserRole[] = Object.values(UserRole);

export function getUserRoleName(role: UserRole): string {
  switch (role) {
    case UserRole.ADMIN:
      return "Administratör";
    case UserRole.USER_ADMIN:
      return "Användaradmin";
    case UserRole.EMPLOYEE:
      return "Medarbetare";
    case UserRole.PAYROLL:
      return "Ekonomi";
    case UserRole.INTERNAL_INSTALLER:
      return "Intern installatör";
    case UserRole.EXTERNAL_INSTALLER:
      return "Extern installatör";
    case UserRole.SALES:
      return "Säljare";
    default:
      return "Okänd";
  }
}

export function getUserStateName(state: UserState): string {
  switch (state) {
    case "CREATED":
      return "E-post ej verifierad";
    case "PENDING":
      return "Väntar på godkännande";
    case "ACTIVE":
      return "Aktiv";
    case "INACTIVE":
      return "Inaktiverad";
    default:
      return "Okänd";
  }
}
